/* eslint-disable object-shorthand */
import React from 'react';
import { CarouselOverflow as Carousel } from "@hm-group/fabric-components/components/CarouselOverflow";
import { HeadingLarge } from "@hm-group/fabric-components/components/Typography";
import { useAddToFavourites } from "@hm-group/frontend-utils-react/hooks";
import { useRemoveFromFavourites } from "@hm-group/frontend-utils-react/hooks";
import { default as ProductTile } from "@hm-group/igd-shared-components/ProductTile";
import { default as isTouchDevice } from "@pb/utils/isTouchDevice";
import { default as useLazyPreloadCarousel } from "@pb/utils/lazyPreloadCarousel";
import { default as getCurrentBreakpoint } from "@pb/utils/getCurrentBreakpoint";
import { default as IS_CLIENT } from "@pb/utils/constants/isClient";
import cn from 'classnames';
import styles from './ProductCarouselNS.module.scss';
const defaultNumOfItemsPerSlide = {
    default: 2,
    xsmall: 2,
    small: 2,
    medium: 4,
    large: 4,
    xlarge: 5,
    xxl: 5,
};
const ProductCarouselNS = ({ title, className, products, labels, linkClickCallback, useModelAsDefault, reserveHeightAspectRatio, shouldLazyPreload = false, onFavouritesClick, }) => {
    const breakpointState = IS_CLIENT ? getCurrentBreakpoint() : 'medium';
    const itemsPerSlide = defaultNumOfItemsPerSlide[breakpointState];
    const indices = Array.from(products === null || products === void 0 ? void 0 : products.keys());
    const cachedImages = useLazyPreloadCarousel(shouldLazyPreload, itemsPerSlide, indices, breakpointState, 0, false);
    if (!(products === null || products === void 0 ? void 0 : products.length)) {
        return null;
    }
    return (React.createElement("section", { className: cn(styles.wrapper, className, isTouchDevice() ? styles.touchAdjustments : '') },
        React.createElement(HeadingLarge, { Tag: "h2" }, title),
        React.createElement(Carousel, { slideSpacing: "xsmall", labels: labels, slidesPerBreakpoint: defaultNumOfItemsPerSlide, offset: "half" }, products.map((product, index) => {
            const { articleCode } = product;
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const addToFavourites = useAddToFavourites({
                articleCode: (articleCode === null || articleCode === void 0 ? void 0 : articleCode.toString()) || '',
            });
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const removeFromFavourites = useRemoveFromFavourites({
                articleCode: (articleCode === null || articleCode === void 0 ? void 0 : articleCode.toString()) || '',
            });
            return (
            // @ts-ignore
            React.createElement(ProductTile, Object.assign({ key: articleCode, linkClickCallback: linkClickCallback, useModelAsDefault: useModelAsDefault, shouldLazyLoad: shouldLazyPreload && !(cachedImages === null || cachedImages === void 0 ? void 0 : cachedImages.has(index)), reserveHeightAspectRatio: reserveHeightAspectRatio, articleCode: articleCode, favouritesButton: {
                    favouritesLabels: {
                        favouriteActive: 'active',
                        favouriteInactive: 'inactive',
                        popupConfirm: 'confirm',
                        close: 'close',
                        favouriteslimitText: 'favouriteslimitText',
                        favouriteslimitTitle: 'favouriteslimitTitle',
                        favouriteErrorText: 'favouriteErrorText',
                        favouriteErrorTitle: 'favouriteErrorTitle',
                        favouriteRemoveError: 'favouriteRemoveError',
                    },
                    initialFavouriteStatus: false,
                    articleCode: (articleCode === null || articleCode === void 0 ? void 0 : articleCode.toString()) || '',
                    onFavouritesClick: onFavouritesClick,
                    removeActions: removeFromFavourites,
                    addActions: addToFavourites,
                }, variant: "northstar-small" }, product)));
        }))));
};
export default ProductCarouselNS;
//# sourceMappingURL=ProductCarouselNS.js.map